<template>
  <div id="wangeditor">
    <div ref="editorElem" style="text-align:left"></div>
  </div>
</template>
<script>
import E from "wangeditor";
import * as homeConst from "../apiconfig/index.js";
export default {
  name: "editorElem",
  data() {
    return {
      port: homeConst.baseUrl + "/",
      editor: null,
      editorContent: ""
    };
  },
  props: ["catchData", "content"], // 接收父组件的方法

  watch: {
    content() {
      this.editor.txt.html(this.content ? this.content : "");
    }
  },
  mounted() {
    var port = this.port;
    var imgUrl = "";
    this.editor = new E(this.$refs.editorElem);

    this.editor.customConfig.onchange = html => {
      this.editorContent = html;
      this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
    };
    this.editor.customConfig.uploadImgServer =
      this.port + "api/public/Upload/UploadImage/";//上传图片的地址
    this.editor.customConfig.withCredentials = true; //跨域
    this.editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024; //图片大小限制
    this.editor.customConfig.uploadFileName = "Image"; //自定义 fileName
    // 下面是最重要的的方法
    this.editor.customConfig.uploadImgHooks = {
      before: function(xhr, editor, files) {},
      success: function(xhr, editor, result) {
        this.imgUrl = result.msg;
      },
      fail: function(xhr, editor, result) {
        var res = xhr.data;
      },
      error: function(xhr, editor) {},
      timeout: function(xhr, editor) {},
      customInsert: function(insertImg, result, editor) {
        let url = result.msg;
        insertImg(port + url);
      }
    };
    this.editor.customConfig.debug = true;
    this.editor.customConfig.showLinkImg = false;
    this.editor.create(); // 创建富文本实例
    if (!this.content) {
      this.editor.txt.html("");
    } else {
      this.editorContent = this.content;
      this.editor.txt.html(this.editorContent);
    }
  }
};
</script>
<style>
.w-e-toolbar{
  flex-wrap:wrap;
}
.w-e-text-container{
  height: auto!important;
  min-height: 300px!important;
}
</style>
